<template>
  <vs-popup class="add-new-company-holiday" id="popup" title="CREATE SUNDRY ITEM INVENTORY" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">
          <vx-card subtitle="QC TEST" cardBorder>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="q_c_status" name="q_c_status" rules="required" v-slot="{ errors }">
                  <small class="label">Status</small>
                  <v-select :clearable="true" name="status" placeholder="" v-model="form.status" label="name"
                    :reduce="option => option.value"
                    :options="[{ name: 'Approved', value: 'approved' }, { name: 'Rejected', value: 'rejected' }]"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Is item damaged?</small>
                  <vs-switch v-model="form.not_damaged" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Is item dry?</small>
                  <vs-switch v-model="form.dry" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Is item clean?</small>
                  <vs-switch v-model="form.clean" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Shrink wrap intact?</small>
                  <vs-switch v-model="form.shrink_wrap_intact" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                  <small class="label">Notes</small>
                  <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
          <vx-card class="mt-8" v-if="form.status === 'approved'" subtitle="BATCH FOR QC TEST" cardBorder>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="total_quantity" name="total_quantity" :rules="`required|integer|min_qty:${rm_item.quantity_pending_to_receive}`" v-slot="{ errors }">
                  <small class="label">Total Quantity ({{ rm_item.sold_in || 'N/A' }})</small>
                  <vs-input type="number" step="0.01" v-model="stock_inventory_form.total_quantity"
                    name="company_product_code" class="w-full required" label="" :danger="!!errors[0]"
                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="supplier_batch_no" name="supplier_batch_no" rules="required" v-slot="{ errors }">
                  <small class="label">Supplier Batch Number</small>
                  <vs-input v-model="stock_inventory_form.supplier_batch_no" name="supplier_batch_no" class="w-full required" label=""
                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="location" name="location" rules="required" v-slot="{ errors }">
                  <small class="label">Shelf Location</small>
                  <vs-input v-model="stock_inventory_form.location" name="location" class="w-full required" label=""
                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
            </div>
          </vx-card>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const SundrySupplierRepository = RepositoryFactory.get('sundry')
const ManufacturingRepository = RepositoryFactory.get('manufacturing');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from "vue-select";

function initialState() {
  return {
    open: false,
    id: '',
    rm_item: {},
    form: {
      not_damaged: false,
      dry: false,
      clean: false,
      shrink_wrap_intact: false,
      notes: '',
      q_c_status: ''
    },
    stock_inventory_form: {},
  }
}

export default {
  name: 'AddQcTestRmOrderItemPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(rm_item) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.rm_item = rm_item
        this.stock_inventory_form.total_quantity = this.rm_item.quantity_pending_to_receive + ''
      } catch (error) {

      }
    },
    async onClickCreateQcTest() {
      const vue = this;
      this.$vs.loading();
      try {
        this.form.sundry_item_order_item_id = this.rm_item.id
        this.form.quantity = this.stock_inventory_form.total_quantity
        let { data } = (await SundrySupplierRepository.createSundryOrderItemQcTest(this.form)).data
        this.showSuccessMessage('Item QC Test added!');
        if(this.form.status === 'approved') {
          await this.onClickAssign(data.id)
        } else {
          await vue.$parent.refreshData();
          this.open = false;
        }
      } catch (e) {
        this.$vs.loading.close();
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickAssign(qc_id) {
        const vue = this
        await this.$vs.loading()
        try {
          const payload = {
            sundry_item_order_item_id: this.rm_item.id,
            sundry_item_id: this.rm_item.sundry_item_id,
            total_quantity: this.stock_inventory_form.total_quantity,
            location: this.stock_inventory_form.location,
            sundry_order_item_q_c_test_id: qc_id,
            supplier_batch_no: this.stock_inventory_form.supplier_batch_no
          }
          await ManufacturingRepository.createSundryItemInventory(payload)
          this.showSuccessMessage('Sundry Item Stock Inventory created!')
          vue.open = false;
          await vue.$parent.refreshData()
        } catch (e) {
          this.showErrorMessage(e)
        }
        this.$vs.loading.close()

    },
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-company-holiday>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}</style>
